import config from "config";

/**
 * Parses browser cookies to get value of specified name
 * @param name The string to search cookies for
 * @returns string value of cookie if found, or "(not set)" if not
 */
export function getCookieValueByName(cookieName: string) {
  const decodedCookies = decodeURIComponent(document.cookie);
  const cookiesArray = decodedCookies.split(";");
  for (const cookie of cookiesArray) {
    const [key, value] = cookie.trim().split("=");
    if (key === cookieName) {
      const cvalue = value.split(".");
      if (cookieName === `_ga_${config.GA_TRACKING_ID_CONSOLIDATED_STREAM}`) {
        return `${cvalue[2]}.${cvalue[5]}`;
      }
      if (cookieName === "_ga") {
        return `${cvalue[2]}.${cvalue[3]}`;
      }
      return value;
    }
  }
  return "(not set)";
}
